<modal-sidebar
	class="appointment-details-sidebar"
	[visible]="isVisible"
	(closeModal)="closeSidebar()"
	[closeOnClickOutside]="false"
>
	<div *ngIf="isLoading" body class="zk-flex zk-h-full zk-items-center zk-justify-center">
		<freud-loader size="md" [bgColor]="false"></freud-loader>
	</div>

	<appointment-details-header *ngIf="!isLoading" header [isFirstSession]="isFirstSession" [event]="event" [contact]="contact"></appointment-details-header>
	<appointment-details-body
		*ngIf="!isLoading"
		body
		[isFirstSession]="isFirstSession"
		[event]="event"
		[contact]="contact"
		[sessionHasTask]="sessionHasTask"
		[sessionTask]="sessionTask"
	></appointment-details-body>
	<appointment-details-footer (rescheduleEvent)="emitRescheduleEvent()"
		(scheduleNewSessionEvent)="emitScheduleNewSessionEvent()" (showEvents)="closeSidebar()"
		(refreshEvents)="refreshEvents.emit();"
		(isLoadingEvent)="isLoading = true;" footer [event]="event" [isLoading]="isLoading"
		[hasContactId]="event?.contactId"
		[hasRefUserId]="contact?.refUserId"
		></appointment-details-footer>
</modal-sidebar>
